import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Commercial EPC', path: '/commercial-epc' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'About', path: '/about' },
    { name: 'Accreditations', path: '/accreditations' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      {/* Top bar */}
      <div className="text-white py-2" style={{ background: 'linear-gradient(to right, #16a34a, #06b6d4)' }}>
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:01392980077" className="flex items-center gap-1 hover:opacity-80">
              <Phone className="w-3 h-3" />
              <span className="hidden sm:inline">01392 980077</span>
            </a>
            <a href="mailto:info@energyperformancedirect.co.uk" className="flex items-center gap-1 hover:opacity-80">
              <Mail className="w-3 h-3" />
              <span className="hidden sm:inline">info@energyperformancedirect.co.uk</span>
            </a>
          </div>
          <div className="text-xs font-medium">
            No VAT to pay
          </div>
        </div>
      </div>

      {/* Main navbar */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_energy-direct-revamp/artifacts/qrurduho_Big%20Logo.jpg" 
              alt="Energy Performance Direct" 
              className="h-12 sm:h-14"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-green-600'
                    : 'text-gray-700 hover:text-green-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking">
              <Button 
                data-testid="nav-book-now-btn"
                className="text-white px-6"
                style={{ background: 'linear-gradient(to right, #16a34a, #06b6d4)' }}
              >
                Book Now
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden pb-4 border-t" data-testid="mobile-menu">
            <div className="flex flex-col gap-2 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                  className={`py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-green-50 text-green-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/booking" onClick={() => setIsOpen(false)}>
                <Button 
                  data-testid="mobile-book-now-btn"
                  className="w-full text-white"
                  style={{ background: 'linear-gradient(to right, #16a34a, #06b6d4)' }}
                >
                  Book Now
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;